import { render, staticRenderFns } from "./CourseInfo.vue?vue&type=template&id=3bfc9834&scoped=true"
import script from "./CourseInfo.vue?vue&type=script&lang=ts"
export * from "./CourseInfo.vue?vue&type=script&lang=ts"
import style0 from "./CourseInfo.vue?vue&type=style&index=0&id=3bfc9834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfc9834",
  null
  
)

export default component.exports